<mat-spinner
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-labelledby]="ariaLabelledBy() || null"
    [color]="context()"
    [style.--mat-progress-spinner-active-indicator-color]="indicatorColor()"
    [diameter]="computedDiameter()"
    class="qpx-loader"
    [ngClass]="inputClasses()"
/>
